/**
 * MONOWHEEL — campaign gift (iHAVECPU)
 *
 * Shopify's Buy-X-Get-Y discounts only discount items that are ALREADY in the
 * cart; they never add the gift themselves. This script bridges that gap:
 *
 *   customer types iHAVECPU on the cart page/drawer
 *     -> if a qualifying scooter is in the cart, the gift line is added first
 *     -> then the theme applies the discount code as usual
 *
 * On the cart page it also drops an orphaned gift line when the qualifying
 * product is removed, so the free item can't travel to checkout on its own.
 *
 * Everything is scoped to the exact campaign code: any other code goes through
 * the theme's normal path untouched.
 */
(function () {
  var CODE = 'IHAVECPU';
  var GIFT_VARIANT = 43153790042174;
  var QUALIFYING_VARIANTS = [
    42485657927742, // Ninebot E2 Pro
    42485658058814, // Ninebot E3
    42485658124350, // Ninebot F3
    42485658157118, // Ninebot MAX G3
    42485658189886, // Segway Gokart Pro2
    42485658222654, // Segway SuperScooter GT3
    42485658452030  // Segway ZT3 Pro
  ];
  var MSG_NO_QUALIFY = 'ต้องมีสกู๊ตเตอร์ที่เข้าร่วมแคมเปญในตะกร้าก่อน จึงจะใช้รหัสนี้ได้';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var passthrough = false;

  function json(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json();
    });
  }

  function getCart() {
    return json(root + 'cart.js', { headers: { Accept: 'application/json' } });
  }

  function postCart(path, payload) {
    return json(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function hasVariant(cart, id) {
    return (cart.items || []).some(function (item) {
      return item.variant_id === id;
    });
  }

  function qualifies(cart) {
    return (cart.items || []).some(function (item) {
      return QUALIFYING_VARIANTS.indexOf(item.variant_id) > -1;
    });
  }

  function showError(form, message) {
    var target = form.lastElementChild;
    if (!target) return;
    target.textContent = message;
    target.removeAttribute('hidden');
  }

  // ── Intercept the campaign code before the theme applies it ──
  document.addEventListener(
    'click',
    function (event) {
      if (passthrough) return;

      var button =
        event.target && event.target.closest
          ? event.target.closest('form[is="cart-discount"] [type="submit"]')
          : null;
      if (!button) return;

      var form = button.closest('form[is="cart-discount"]');
      var input = form && form.querySelector('[name="discount"]');
      if (!input) return;
      if ((input.value || '').trim().toUpperCase() !== CODE) return; // other codes: untouched

      event.preventDefault();
      event.stopImmediatePropagation();

      getCart()
        .then(function (cart) {
          if (!qualifies(cart)) {
            showError(form, MSG_NO_QUALIFY);
            return;
          }
          var ready = hasVariant(cart, GIFT_VARIANT)
            ? Promise.resolve()
            : postCart('cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1 }] });

          return ready.then(function () {
            passthrough = true;
            button.click(); // hand back to the theme to apply the code
            setTimeout(function () {
              passthrough = false;
            }, 2000);
          });
        })
        .catch(function (error) {
          passthrough = false;
          console.error('[campaign-gift]', error);
        });
    },
    true // capture: runs before the theme's own handler on the button
  );

  // ── Cart page only: drop an orphaned gift line ──
  if (/\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search)) {
    getCart()
      .then(function (cart) {
        if (!hasVariant(cart, GIFT_VARIANT) || qualifies(cart)) return;
        return postCart('cart/change.js', { id: String(GIFT_VARIANT), quantity: 0 }).then(function () {
          window.location.reload();
        });
      })
      .catch(function (error) {
        console.error('[campaign-gift cleanup]', error);
      });
  }
})();
